import React, {Component, ReactNode} from 'react'
import SearchIcon from '@mui/icons-material/Search'
import {CodeMasterInterface} from '../../CodeMaster'
import {Colors, FontFamily, FontSize} from '../../styledComponents/Constants'
import styled from 'styled-components'
import {Box, Tab, Tabs} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {LeftRowFlexContainer} from '../../styledComponents/FlexComponents'

interface Props {
    onChangeCategory: (selectedCategoryList: CodeMasterInterface[]) => void
    categoryList: CodeMasterInterface[]
    selectedCategoryList: CodeMasterInterface[]
    displayAllButton?: boolean
    newDesign?: boolean
    noScrolling?: boolean
}

interface State {
}

class ScrollableCategorySelector extends Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props)

        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount(): void {
    }

    handleChange(event: React.ChangeEvent<{}>, value: number): void {
        let {displayAllButton} = this.props
        const {selectedCategoryList, categoryList} = this.props
        let newSelectedCategoryList: CodeMasterInterface[] = [...selectedCategoryList]

        if (!displayAllButton) {
            displayAllButton = false
        }
        if (displayAllButton) {
            if (value === 0) {
                this.props.onChangeCategory([])
                return
            }
            value -= 1
        }
        const indexOfSelectedCategory = selectedCategoryList.indexOf(categoryList[value])
        if (indexOfSelectedCategory !== -1) {
            newSelectedCategoryList = selectedCategoryList
                .filter(category => category !== categoryList[value])
        } else {
            newSelectedCategoryList.push(categoryList[value])
        }

        this.props.onChangeCategory(newSelectedCategoryList)
    }

    render(): ReactNode {
        const {categoryList, displayAllButton, selectedCategoryList, noScrolling} = this.props
        if (categoryList.length <= 1) {
            return null
        }

        const newDesign = this.props.newDesign ?? false

        return <>
            <SelectorArea newDesign={newDesign}>
                {
                    !newDesign &&
                    <SelectCategoryTag>
                        <StyledSearchIcon/><Box width={2}/> 絞り込み
                    </SelectCategoryTag>
                }
                <StyledTabs
                    variant="scrollable"
                    scrollButtons={noScrolling ? false : true}
                    value={false}
                    onChange={this.handleChange}
                    sx={{paddingLeft: '7px'}}
                >
                    {
                        displayAllButton &&
                        <StyledTab
                            label="すべて"
                            toggle={selectedCategoryList.length === 0 ? 'true' : 'false'}
                        />
                    }
                    {
                        categoryList.map((category, index) => (
                            <StyledTab
                                key={index}
                                label={category.label}
                                toggle={selectedCategoryList.includes(category) ? 'true' : 'false'}
                            />
                        ))
                    }
                </StyledTabs>
            </SelectorArea>
        </>
    }
}

export default ScrollableCategorySelector

const SelectorArea = styled.div<{ newDesign: boolean }>`
  ${props => !props.newDesign && `
    background-color: Colors.Surface;
  `}
`

const StyledSearchIcon = styled(SearchIcon)`
  margin: 4px 4px 3px 4px
`

const StyledTabs = withStyles({
    root: {
        minHeight: 0,
        marginRight: 0,
        marginLeft: 0,
        alignItems: 'center',
    },
    scroller: {
        paddingTop: '10px',
        paddingBottom: '10px',
    },
    indicator: {
        display: 'none',
    },
    scrollButtons: {
        '&.MuiTabs-scrollButtons': {
            display: 'flex'
        },
        width: '25px',
        height: '25px',
        backgroundColor: Colors.Surface,
    },
})
(Tabs)

const StyledTab = styled(Tab)<{ toggle: string }>`
  &.MuiTab-root {
    background-color: ${Colors.Surface};
    border-radius: 15px;
    border: solid 1px ${props => props.toggle === 'true' ? Colors.Primary : Colors.AccentLight};
    color: ${props => props.toggle === 'true' ? Colors.Primary : Colors.Body};
    min-width: auto;
    min-height: auto;
    margin-right: 7px;
    line-height: 1.5;
    padding: 3px 10px;
    opacity: 1;
    font-size: ${FontSize.Middle};
    font-family: ${FontFamily.ResidentDefault};
  }
`

const SelectCategoryTag = styled(LeftRowFlexContainer)`
  font-Size: ${FontSize.Small};
  color: ${Colors.AccentDark};
  margin-left: 15px;
`
